import React from 'react';
import { GiftIcon, ImageIcon } from 'lucide-react';
import { bonuses, pricing } from '../data/content';
export function Bonuses() {
  return <section className="bg-petrol py-20 text-paper sm:py-24" aria-labelledby="bonuses-title" data-id="element-19" data-mp="pj6cm4pkakr0">
      <div className="mx-auto max-w-[880px] px-5 sm:px-8" data-id="element-20" data-mp="aujwi0s41oyq">
        <h2 id="bonuses-title" className="flex items-center justify-center gap-3 text-center font-display text-[2rem] leading-tight sm:text-5xl" style={{
        fontSize: "32px",
        fontWeight: "500"
      }} data-id="element-21" data-mp="ftmwh6t8h4zu">
          <GiftIcon className="h-7 w-7 shrink-0 text-terra-soft" strokeWidth={1.6} aria-hidden="true" data-id="element-22" data-mp="5wi60uscund8" />
          Y además recibís 5 bonos profesionales
        </h2>
        <p className="mt-4 text-center text-lg text-cream/70" data-id="element-23" data-mp="3o3y55r1ct072">Incluidos de regalo con tu Megapack.</p>

        <ul className="mt-12 space-y-4" data-id="element-24" data-mp="3t2j5rrkiplw1">
          {bonuses.map(b => <li key={b.label} className="grid gap-6 rounded-2xl bg-petrol-deep p-6 ring-1 ring-petrol-line sm:grid-cols-[1fr_200px] sm:p-8" data-id="element-25" data-mp="1mb1kdchn6j9r">
              <div className="flex flex-col" data-id="element-26" data-mp="3ie6j3kp847x9">
                <span className="self-start rounded-md bg-terra-soft px-2.5 py-1 text-[11px] font-bold uppercase tracking-[0.16em] text-petrol-deep" data-id="element-27" data-mp="3icvcld4e8m2g">
                  {b.label}
                </span>
                <h3 className="mt-4 font-display text-2xl text-paper" data-id="element-28" data-mp="3r68g1903362s">{b.name}</h3>
                <p className="mt-2 leading-relaxed text-cream/70" data-id="element-29" data-mp="3n67smyv0bkjl">{b.description}</p>
                <div className="mt-auto flex items-center gap-3 pt-6" data-id="element-30" data-mp="2zeskgpgju90f">
                  <span className="text-sm text-cream/60" data-id="element-31" data-mp="2ughbsi1zq4js">Valor: {b.value}</span>
                  <span className="rounded-md border border-sage/40 bg-sage/15 px-2.5 py-1 text-xs font-semibold uppercase tracking-[0.1em] text-sage-soft" data-id="element-32" data-mp="2uiu0de297d5t">
                    Hoy incluido
                  </span>
                </div>
              </div>
              <div className="flex aspect-[4/3] flex-col items-center justify-center gap-2 rounded-xl border-2 border-dashed border-petrol-line text-cream/50 sm:aspect-auto" data-id="element-33" data-mp="np01oz4keoct">
                <ImageIcon className="h-6 w-6" strokeWidth={1.5} aria-hidden="true" data-id="element-34" data-mp="3cjfxta97slhv" />
                <span className="text-xs font-medium uppercase tracking-[0.14em]" data-id="element-35" data-mp="3hhr81m3f8y0m">[Mockup del bono]</span>
              </div>
            </li>)}
        </ul>

        <div className="mx-auto mt-10 w-fit rounded-xl border border-terra-soft/30 bg-petrol-deep px-6 py-4 text-center text-sm font-semibold uppercase tracking-[0.14em] text-terra-soft sm:text-base" data-id="element-36" data-mp="3lke1tsjnkt0g">
          Valor total de los 5 bonos: {pricing.bonusTotal}
        </div>
      </div>
    </section>;
}